import React from "react";

export default function Nav({ cartCount, onOpenCart, rightSlot }) {
  return (
    <nav className="nav">
      <div className="nav-logo">
        {/* ── IADVL Presidential Initiative ── */}
        <div className="iadvl-mark">
          <div className="iadvl-pi-badge">
            <div className="iadvl-pi-line1">IADVL</div>
            <div className="iadvl-pi-line2">Presidential Initiative</div>
          </div>
        </div>

        {/* <div className="nav-div" /> */}

        {/* ── GOQii ── */}
        {/* <div className="goqii-mark">
          <img
            src="https://storecdn.goqii.com/media/goqiiweb/assets/images/site-logo.png"
            alt="GOQii"
            className="nav-goqii-logo"
            loading="lazy"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        </div> */}
      </div>

      <div className="nav-right">
        {rightSlot !== undefined ? rightSlot : (
          <>
            <span className="nav-pill">Members Exclusive · 2026–27</span>
            <button className="nav-cart-btn" onClick={onOpenCart}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="9" cy="21" r="1"/>
                <circle cx="20" cy="21" r="1"/>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
              </svg>
              <span className="nav-badge">{cartCount}</span>
            </button>
          </>
        )}
      </div>
    </nav>
  );
}
